import get from 'lodash/get'
import {ICollation} from "../../components/planner/@models";

export const getTotalStops = (collations: Array<ICollation>) => collations.filter((collation : ICollation) => (get(collation, 'shipmentIds', []) as number[]).some(shipmentId => shipmentId > -1)).length
